import * as React from "react";
import styled from "styled-components";
import { capitalize } from "lodash";

import { ICustomer } from "../api/customers.api";

const StatusWrapper = styled("span")`
  font-weight: ${({ theme }) => theme.fonts.weights.bold};

  &.deactivated {
    color: ${({ theme }) => theme.colors.error};
  }

  &.active {
    color: ${({ theme }) => theme.colors.success};
  }

  &.suspended, &.over-credit-limit {
    color: ${({ theme }) => theme.colors.warn};
  }
`;

/**
 * Gets the customer's account status
 */
const CustomerDropStatus = ({ status }: Pick<ICustomer, "status">) => {
  return (
    <StatusWrapper className={status || ""}>
      {capitalize(status || "").replace(/-/g, " ")}
    </StatusWrapper>
  );
};

export default CustomerDropStatus;
